"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("../constants");

var _styles = require("../styles");

var _componentButton = _interopRequireDefault(require("@doordash/component-button"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ToastContent = function ToastContent(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      action = _ref.action,
      position = _ref.position,
      insetFromEdge = _ref.insetFromEdge;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  var hasAction = typeof action !== 'undefined' && typeof action.text !== 'undefined' && typeof action.onClick === 'function';
  return /*#__PURE__*/_react["default"].createElement(_styles.ToastContainer, {
    insetFromEdge: insetFromEdge,
    position: position
  }, /*#__PURE__*/_react["default"].createElement(_styles.ToastContentContainer, {
    role: "alert",
    "aria-live": "off",
    hasAction: hasAction
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.InlineChildren, {
    alignItems: _designLanguage.InlineChildren.Alignment.Center,
    justifyContent: _designLanguage.InlineChildren.Justification.SpaceBetween
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.InlineChildren, {
    alignItems: _designLanguage.InlineChildren.Alignment.Center
  }, icon && /*#__PURE__*/_react["default"].createElement(_designLanguage.Icon, {
    type: icon,
    color: _designLanguage.Text.Colors.ToastInformationalForeground
  }), /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    styles: _designLanguage.Text.Styles.ToastBody,
    color: _designLanguage.Text.Colors.ToastInformationalForeground
  }, text)), hasAction && /*#__PURE__*/_react["default"].createElement(_designLanguage.Theming, {
    overrides: (0, _constants.buttonOverridesFromTheme)(theme)
  }, /*#__PURE__*/_react["default"].createElement(_componentButton["default"], {
    isInline: true,
    type: _componentButton["default"].Types.FlatPrimary,
    onClick: action.onClick,
    padding: _componentButton["default"].Padding.None
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    color: _designLanguage.Text.Colors.ButtonFlatPrimaryForeground,
    styles: _designLanguage.Text.Styles.ToastAction
  }, action.text))))));
};

ToastContent.propTypes = _constants.TOAST_CONTENT_PROPTYPES;
ToastContent.defaultProps = {};
var _default = ToastContent;
exports["default"] = _default;